<template>
  <div class="PersonalPresetService">
    <div class="third-rea">
      <div class="third-formOne" style="height:60px">
        <div class="formOne-btn">
          <div class="btn-left">
            <span class="left-back-icon" @click="goBack">
              <i class="el-icon-arrow-left"></i>
              <span class="left-back-title">返回</span>
            </span>
            <span class="left-back-shu">
              <span class="left-back-shu-content"></span>
            </span>
            <span class="left-back-content">预置个人服务》{{IDlist.userName}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="third-one ">
      <div class="third-do-btn">
        <div class="do-btn-left">
          <el-button class="do-btn-two" type="default" icon="el-icon-plus" @click="addData">新增</el-button>
          <el-button class="do-btn-two" type="default" icon="el-icon-delete" @click="removedata">移除</el-button>
          <el-button
            class="do-btn-four"
            type="default"
            icon="el-icon-search"
            @click="hignSearch"
          >数据筛选</el-button>
          <el-button
            class="do-btn-four"
            type="default"
            icon="el-icon-refresh-left"
            @click="Reset_boos"
          >重置</el-button>
        </div>
        <!-- <div class="do-btn-right">
          <div class="do-btn-check">
            <el-checkbox class="btn-check-item" v-model="checked" @change="changeHign"></el-checkbox>
            <span class="btn-check-span">显示高级功能</span>
          </div>
          <div class="do-btn-hign-list" v-if="checked">
            <sort-data
              :tableRow="tableRow"
              @showList="getTableList"
              sessionOriginalName="otherSortOrignalData"
              sessionResultName="PersonalPresetService"
            ></sort-data>
            <display-field
              :selectList="tableRow"
              sessionOriginalName="otherDisplayFiedOrignal"
              @setDataOrder="getDataOrder"
              sessionResultName="PersonalPresetServiceChange"
            ></display-field>
          </div>
        </div> -->
        <div class="add-member-modal">
          <el-dialog
            v-el-drag-dialog
            width="940px"
            :visible.sync="dialogTableVisible"
            @close="closeDialog"
            :close-on-click-modal="false"
          >
            <div slot="title" class="member-modal-title" style="line-height:14px">
              <span class="modal-title-span">新增预置服务</span>
            </div>
            <div class="member-modal-content">
              <div class="third-rea">
                <div class="third-btn">
                  <div class="btn-left">检索条件</div>
                  <div class="btn-right">
                    <el-button class="btn-two" type="primary" @click="search">查询</el-button>
                    <el-button class="btn-two" type="default" @click="Reset">重置</el-button>
                  </div>
                </div>
                <div class="third-search">
                  <el-form :model="add_getData" ref="add_getData" :inline="true" label-width="76px">
                    <div class="search-row">
                      <div class="row-item member-search-item">
                        <el-form-item label="服务名称" prop="serviceName">
                          <template>
                            <el-input
                              :maxlength="30"
                              v-model="add_getData.serviceName"
                              placeholder="请输入"
                              class="item-input"
                            ></el-input>
                          </template>
                        </el-form-item>
                      </div>
                      <div class="row-item member-search-item">
                        <el-form-item label="使用环境" prop="userEnvironment">
                          <template>
                            <el-input
                              :maxlength="30"
                              v-model="add_getData.userEnvironment"
                              placeholder="请输入"
                              class="item-input"
                            ></el-input>
                          </template>
                        </el-form-item>
                      </div>
                      <div class="row-item member-search-item">
                        <el-form-item label="服务状态" prop="serviceStatus">
                          <template>
                            <el-select
                              class="item-input"
                              v-model="add_getData.serviceStatus"
                              placeholder="请选择"
                            >
                              <el-option key="0" value="0" label="已下架"></el-option>
                              <el-option key="1" value="1" label="已上架"></el-option>
                            </el-select>
                          </template>
                        </el-form-item>
                      </div>
                    </div>
                  </el-form>
                </div>
              </div>
              <div class="third-one">
                <el-table
                  height="330px"
                  :row-key="getRowKey_registCount"
                  :data="add_tableData"
                  @select="rowchange"
                  @select-all="handleSelectionChange_registCount"
                  ref="multipleTable"
                  class="third-tableThree tableThree-add my-table-geadd"
                  border
                  stripe
                  v-loading="loading"
                >
                  <el-table-column type="selection" width="32px" :reserve-selection="true"></el-table-column>
                  <el-table-column
                    min-width="100px"
                    prop="serviceName"
                    label="服务名称"
                    :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column
                    min-width="100px"
                    prop="userEnvironmentValue"
                    label="使用环境"
                    :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column
                    min-width="100px"
                    prop="status_name"
                    label="服务状态"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.status==0" style="color:red">{{ scope.row.status_name}}</span>
                      <span
                        v-if="scope.row.status==1"
                        style="color:green"
                      >{{ scope.row.status_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    min-width="100px"
                    prop="createTime"
                    label="创建时间"
                    :show-overflow-tooltip="true"
                  ></el-table-column>
                </el-table>
                <div class="third-page add-modal-page">
                  <div class="page-left">
                    <el-button
                      :disabled=" tableData_registCoun_disabled "
                      type="primary"
                      @click="toggleSelection"
                    >选中全部</el-button>
                    <el-button type="primary" @click="toggleSelection_clear">取消全选</el-button>
                    <span class="left-data">已选中{{change_count }}条数据</span>
                  </div>
                  <el-pagination
                    class="page-right"
                    @size-change="handleSizeChange_registCount"
                    @current-change="handleCurrentChange_registCount"
                    :current-page="add_pageIndex"
                    background
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="add_pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="add_total"
                  ></el-pagination>
                </div>
              </div>
            </div>
            <div slot="footer" class="member-modal-footer" style="line-height: 0px;">
              <el-button class="modal-footer-two" @click="dialogTableVisible = false">取消</el-button>
              <el-button class="modal-footer-two" type="primary" @click="register">确定</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
      <div class="sord-modal" slot="content">
        <el-table
          ref="PersonalPresetService"
          @selection-change="handleSelectionChange"
          :row-key="getRowKey"
          :data="tableData"
          class="third-tableThree fields-table old-table"
          border
          stripe
          v-loading="tableLoading"
        >
          <el-table-column type="selection" :reserve-selection="true" width="32px"></el-table-column>
          <template v-for="(item, index) in tableDataShow">
            <!-- <template v-for="(item, index) in $store.state.power.selectConfig.eduCollegeInfo"> -->
            <el-table-column
              v-if="item.needKeyValue"
              min-width="100px"
              :prop="item.key"
              :label="item.column"
              :key="index"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span :style="{ 'color':scope.row[item.data_color] }">{{ scope.row[item.key] }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-else
              min-width="100px"
              :prop="item.key"
              :label="item.column"
              :key="index"
              :show-overflow-tooltip="true"
            ></el-table-column>
          </template>
          <el-table-column min-width="100" prop="address" label="排序" fixed="right">
            <template slot-scope="scope">
              <div class="table-do-btn">
                <el-button
                  style="height:auto"
                  icon="el-icon-d-arrow-left"
                  @click=" moveUp(scope.$index, scope.row)"
                ></el-button>
                <el-button
                  style="height:auto"
                  icon="el-icon-d-arrow-right"
                  @click=" moveDown(scope.$index, scope.row )"
                ></el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="third-page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          background
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <new-notice-modal
      :noticeModalVisible="noticeModal_dance"
      :noticeTitle="noticeTitle_dance"
      :noticeType="noticeType_dance"
      :noticeContent="noitceContent_dance"
      :noticeSpec="noticeSpec_dance"
    >
      <template v-slot:footer>
        <template>
          <el-button class="modal-footer-two" @click="noticeModal_dance = false">取消</el-button>
          <el-button class="modal-footer-two" type="primary" @click="withdrawFN_FN">确定</el-button>
        </template>
      </template>
    </new-notice-modal>
    <new-notice-modal
      :noticeModalVisible="noticeModal_duoce"
      :noticeTitle="noticeTitle_duoce"
      :noticeType="noticeType_duoce"
      :noticeContent="noitceContent_duoce"
      :noticeSpec="noticeSpec_duoce"
    >
      <template v-slot:footer>
        <template>
          <el-button class="modal-footer-two" @click="noticeModal_duoce = false">取消</el-button>
          <el-button class="modal-footer-two" type="primary" @click="withdrawFNArr_FN">确定</el-button>
        </template>
      </template>
    </new-notice-modal>
    <new-notice-modal
      :noticeModalVisible="noticeModal_zhuce"
      :noticeTitle="noticeTitle_zhuce"
      :noticeType="noticeType_zhuce"
      :noticeContent="noitceContent_zhuce"
      :noticeSpec="noticeSpec_zhuce"
    >
      <template v-slot:footer>
        <template>
          <el-button class="modal-footer-two" @click="noticeModal_zhuce = false">取消</el-button>
          <el-button class="modal-footer-two" type="primary" @click="register_FN">确定</el-button>
        </template>
      </template>
    </new-notice-modal>
    <hign-modal
      modalTitle="数据筛选"
      :hignModalVisible="hignModal"
      @searchModal="toHignSearch"
      @cancelModal="closeModal"
      :hignOneList="tableRow"
    ></hign-modal>

    <new-notice-modal
      :noticeModalVisible="noticeModal_danshan"
      :noticeTitle="noticeTitle_danshan"
      :noticeType="noticeType_danshan"
      :noticeContent="noitceContent_danshan"
      :noticeSpec="noticeSpec_danshan"
    >
      <template v-slot:footer>
        <template>
          <el-button class="modal-footer-two" @click="noticeModal_danshan = false">取消</el-button>
          <el-button class="modal-footer-two" type="primary" @click="removedata_FN">确定</el-button>
        </template>
      </template>
    </new-notice-modal>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import { mapState } from "vuex";
import { setStore, getStore } from "@/utils/store";
import {
  list,
  add_list,
  save,
  remove,
  changeSort
} from "@/store/mymethod/PresetPersonalService"; //我的
// import Moment from "moment";
export default {
  name: "PersonalPresetService",
  components: {},
  props: {
    IDlist: Object
  },
  data() {
    return {
      tableLoading: false,
      loading: false,
      noticeModal_duoce: false, // 提示弹窗
      noticeType_duoce: 1, // 提示类型
      noitceContent_duoce: "确定撤回？", // 提示信息
      noticeTitle_duoce: "确认操作", // 提示
      noticeSpec_duoce: "", // 标红提示
      //-------------
      noticeModal_dance: false, // 提示弹窗
      noticeType_dance: 1, // 提示类型
      noitceContent_dance: "确定撤回？", // 提示信息
      noticeTitle_dance: "确认操作", // 提示
      noticeSpec_dance: "", // 标红提示
      danceRow: "", //单行数据
      //-------------
      formInline: {
        mpId: 123, //公众号的IM账号
        title: "", //标题 模糊查询，
        content: "", //内容 模糊查询，
        sendUserName: "", //发送人 模糊查询，
        willSchedule: "-1", //是否定时 0是  1不是，默认为-1
        equirment: "-1", //平台 0所有  1android 2IOS，默认为-1
        startTime: "", //发布时间段的开始时间 毫秒级
        endTime: "", //发布时间段的结束时间  毫秒级
        pageIndex: 1, //页码
        pageSize: 40 //每页行数
      },
      valuedata: "", //发布时间

      messageIdsArr: [], //多选
      Back: "ToHistoricalNews",
      selectFBRdata: [], //发布人下拉列表

      //============================================
      hignModal: false, // 高级搜索
      hignSearchRes: "", // 高级检索条件
      //-----------
      total: 0, //总条数
      pageIndex: 1, //页码
      pageSize: 10, //每页条数
      tableRow: [
        {
          column: "服务名称",
          key: "serviceName",
          needKeyValue: true,
          caseKey: "service_name"
        },
        {
          column: "使用环境",
          key: "userEnvironmentValue",
          needKeyValue: false,
          caseKey: "user_environment_value"
        },
        {
          column: "服务状态",
          key: "status_name",
          data_color: "color",
          needKeyValue: true,
          caseKey: "status",
          isCustomList: [
              {
              label: '已上架',
              value: '1'
              },
              {
              label: '已下架',
              value: '0'
              }
          ]
        },
        {
          column: "预置时间",
          key: "createTime",
          needKeyValue: false,
          caseKey: "create_time"
        }
      ],
      tableData: [], //表格数据
      //==============
      add_pageIndex: 1, //页码
      add_pageSize: 10, //每页条数
      add_total: 0, //数据总条数
      add_tableData: [], //表格数据
      add_getData: {
        serviceStatus: "", // 服务状态  0 下架 1上架
        serviceName: "", // 服务名称
        userEnvironment: "" // 使用环境
      },
      dialogTableVisible: false, //检查账号
      total_registCount: 0, //数据总条数
      change_All: false, //全选
      multipleSelection: [], //注册提交数据
      multipleSelection_yes: [], //存储选中数据
      multipleSelection_no: [], //存储全选状态下未选中数据
      change_count: 0, //选中条数
      tableData_registCoun_disabled: false, //全选按钮是否禁用
      //-------------------------
      noticeModal_zhuce: false, // 提示弹窗
      noticeType_zhuce: 1, // 提示类型
      noitceContent_zhuce: "确定进行新增？", // 提示信息
      noticeTitle_zhuce: "确认操作", // 提示
      noticeSpec_zhuce: "", // 标红提示
      //--------
      val_data: [], //多选选中数组
      //--------
      noticeModal_danshan: false, // 提示弹窗
      noticeType_danshan: 1, // 提示类型
      noitceContent_danshan: "移除后，用户在收藏服务中可能无法查看该服务，确定删除吗？", // 提示信息
      noticeTitle_danshan: "确认操作", // 提示
      noticeSpec_danshan: "", // 标红提示
      deletRow: "", //单行删除
      //-----------------------------------------------------
      row_UP: "", //上移的数据
      row_DOWN: "", //下移的数据
      //显示高级功能
      checked: true,
      // 字段展示和顺序需要的参数
      orderConfig: "",
      tableDataShow: []
    };
  },
  computed: {
    // ...mapState({
    //   tableRow: state => state.power.selectConfig.HistoricalNews
    // })
  },
  created() {
    // this.selectList();
    // this.selectFBR();

    // console.log("拿到数据", this.ID);
    const dispField = this.getSessonValue("PersonalPresetServiceChange");
    const tableRow = this.getSessonValue("PersonalPresetService");
    // console.log(this.tableData.length);
    if (dispField) {
      this.orderConfig = dispField;
    }
    if (tableRow) {
      this.tableDataShow = tableRow;
      console.log("字段", this.tableDataShow);
    } else {
      this.tableDataShow = this.tableRow;
      console.log("字段", this.tableDataShow);
    }
    // console.log("字段", this.tableDataShow);
  },
  mounted() {
    this.selectList();
  },
  methods: {
    getDataOrder(value) {
      this.orderConfig = value;
      console.log("改变了数据顺序", this.orderConfig);
      this.selectList();
    },
    getTableList(value) {
      this.tableDataShow = value;
    },
    // 显示高级或者不显示
    changeHign() {
      console.log(this.checked);
    },
    // 上移
    moveUp(index, row) {
      if (this.tableData[index - 1] == undefined && this.pageIndex == 1) {
        this.$message.warning("已经是第一条，不可上移");
        return;
      } else if (
        this.tableData[index - 1] == undefined &&
        this.pageIndex != 1
      ) {
        try {
          const params = {
            relateId: this.IDlist.id, // 角色ma
            pageIndex: this.pageIndex - 1, // 当前页
            pageSize: this.pageSize, // 每页数量
            dataSortStr: "", // 数据排序
            advancedSearch: "" // 高级检索
          };
          list(params).then(res => {
            const data = res.data;
            if (data.status === 1000) {
              this.row_UP = data.result.records[data.result.records.length - 1];
              console.log("this.row_UP", this.row_UP);
              try {
                const params = [row, this.row_UP];
                changeSort(params).then(res => {
                  const data = res.data;
                  if (data.status === 1000) {
                    this.selectList();
                  }else{
                    this.$message.error(data.msg)
                  }
                });
              } catch (err) {
                console.log(err);
              }
            }else{
              this.$message.error(data.msg)
            }
          });
        } catch (err) {
          console.log(err);
        }
      } else {
        this.row_UP = this.tableData[index - 1];
        try {
          const params = [row, this.row_UP];
          changeSort(params).then(res => {
            const data = res.data;
            if (data.status === 1000) {
              this.selectList();
            }else{
            this.$message.error(data.msg)
          }
          });
        } catch (err) {
          console.log(err);
        }
      }
    },
    moveDown(index, row) {
      if (
        this.tableData[index + 1] == undefined &&
        this.pageIndex == Math.ceil(this.total / this.pageSize)
      ) {
        this.$message.warning("已经是最后一条，不可下移");
        return;
      } else if (
        this.tableData[index + 1] == undefined &&
        this.pageIndex != Math.ceil(this.total / this.pageSize)
      ) {
        try {
          const params = {
            relateId: this.IDlist.id, // 角色ma
            pageIndex: this.pageIndex + 1, // 当前页
            pageSize: this.pageSize, // 每页数量
            dataSortStr: "", // 数据排序
            advancedSearch: "" // 高级检索
          };
          list(params).then(res => {
            const data = res.data;
            if (data.status === 1000) {
              this.row_DOWN = data.result.records[0];
              try {
                const params = [row, this.row_DOWN];
                changeSort(params).then(res => {
                  const data = res.data;
                  if (data.status === 1000) {
                    this.selectList();
                  }else{
                    this.$message.error(data.msg)
                  }
                });
              } catch (err) {
                console.log(err);
              }
            }else{
            this.$message.error(data.msg)
          }
          });
        } catch (err) {
          console.log(err);
        }
      } else {
        try {
          this.row_DOWN = this.tableData[index + 1];
          const params = [row, this.row_DOWN];
          changeSort(params).then(res => {
            const data = res.data;
            if (data.status === 1000) {
              this.selectList();
            }else{
            this.$message.error(data.msg)
          }
          });
        } catch (err) {
          console.log(err);
        }
      }
    },
    //移除
    removedata() {
      if (this.val_data == "") {
        this.$message({
          type: "warning",
          message: "请选择数据"
        });
        return;
      }
      this.noticeModal_danshan = true;
    },
    //确定移除
    removedata_FN() {
      let show_data = [];
      this.val_data.forEach(item => {
        show_data.push(item.id);
      });
      this.deletRow = show_data.join();
      try {
        const params = {
          ids: this.deletRow, // 个人服务id  【必填】
          relateId: this.IDlist.id // 账号  【必填】
        };
        remove(params).then(res => {
          const data = res.data;
          if (data.status === 1000) {
            this.selectList();
            this.$refs.PersonalPresetService.clearSelection();
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          }else{
            this.$message.error(data.msg)
          }
        });
      } catch (err) {
        console.log(err);
      }
      this.noticeModal_danshan = false;
    },
    //多选--选中
    handleSelectionChange(val) {
      this.val_data = val;
    },
    //保存选中状态
    getRowKey(row) {
      return row.id;
    },
    //Reset_boos重置
    Reset_boos() {
      this.hignSearchRes = "";
      this.orderConfig = "";
      this.selectList();
    },
    // 高级检索
    hignSearch() {
      this.hignModal = true;
    },
    // 高级检索
    toHignSearch(res) {
      console.log("--------------------", res);
      this.hignSearchRes = res;
      this.pageIndex = 1;
      this.hignModal = false;
      this.selectList();
    },
    // 关闭弹窗
    closeModal() {
      this.hignModal = false;
    },
    //-------------
    //选中本页所有
    handleSelectionChange_registCount(val) {
      //全选状态下-------------有问题
      if (this.change_All) {
        for (let i = 0; i < this.add_tableData.length; i++) {
          if (val.indexOf(this.add_tableData[i]) == -1) {
            this.multipleSelection_no.push(this.add_tableData[i]);
          } else {
            for (let i = 0; i < this.add_tableData.length; i++) {
              for (let j = 0; j < this.multipleSelection_no.length; j++) {
                if (
                  this.add_tableData[i].id == this.multipleSelection_no[j].id
                ) {
                  this.multipleSelection_no.splice(
                    this.multipleSelection_no.indexOf(
                      this.multipleSelection_no[j]
                    ),
                    1
                  );
                }
              }
            }
          }
        }
        this.change_count = this.total_registCount;
        this.change_count =
          this.change_count - this.multipleSelection_no.length;
      } //非全选状态下
      else {
        this.multipleSelection_yes = val;
        this.change_count = val.length;
      }
      // debugger;
    },
    //点击单行
    rowchange(selection, val) {
      //全选状态下
      if (this.change_All) {
        let index = -1;
        for (let i = 0; i < this.multipleSelection_no.length; i++) {
          if (this.multipleSelection_no[i].id === val.id) {
            index = this.multipleSelection_no.indexOf(
              this.multipleSelection_no[i]
            );
          }
        }
        if (index != -1) {
          this.multipleSelection_no.splice(index, 1);
          this.change_count++;
        } else {
          this.multipleSelection_no.push(val);
          this.change_count--;
        }
      } //非全选状态
      else {
        this.multipleSelection_yes = selection;
        this.change_count = selection.length;
      }
    },
    //选中全部
    toggleSelection() {
      this.change_count = this.total_registCount;
      this.change_All = true;
      this.multipleSelection_no = [];
      this.add_tableData.forEach(row => {
        this.$refs.multipleTable.toggleRowSelection(row, true);
      });
    },
    //取消全选
    toggleSelection_clear() {
      this.change_count = 0;
      this.multipleSelection_yes = [];
      this.change_All = false;
      this.multipleSelection_no = [];
      this.$refs.multipleTable.clearSelection();
    },
    //确定注册
    register_FN() {
      try {
        let type;
        let userId = [];
        if (this.change_All == false) {
          type = 3;
          for (let i = 0; i < this.multipleSelection_yes.length; i++) {
            userId.push(this.multipleSelection_yes[i].id);
          }
          userId = userId.join();
        }
        if (this.change_All) {
          type = 1;
          userId = [];
        }
        if (this.change_All && this.multipleSelection_no.length != 0) {
          type = 2;
          for (let i = 0; i < this.multipleSelection_no.length; i++) {
            userId.push(this.multipleSelection_no[i].id);
          }
          userId = userId.join();
        }
        const params = {
          type: type,
          ids: userId,
          relateId: this.IDlist.id // 角色码  【必填】
        };
        save(params).then(res => {
          const data = res.data;
          if (data.status === 1000) {
            this.add_pageIndex=1;
            this.change_count = 0;
            this.add_selectList();
            userId = [];
            this.$refs.multipleTable.clearSelection();
            this.dialogTableVisible=false;//关闭新增框
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          } else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
      this.noticeModal_zhuce = false;
    },
    //注册
    register() {
      // console.log("multipleSelection_yes", this.multipleSelection_yes);
      // console.log("multipleSelection_no", this.multipleSelection_no);
      // return;
      if (!this.change_All) {
        if (this.multipleSelection_yes.length == 0) {
          this.$message({
            type: "warning",
            message: "请选择数据"
          });
          return;
        }
      }
      if (this.change_All) {
        if (this.add_tableData.length == this.multipleSelection_no.length) {
          this.$message({
            type: "warning",
            message: "请选择数据"
          });
          return;
        }
      }
      this.noticeModal_zhuce = true;
    },
    //记住选中状态
    getRowKey_registCount(row) {
      return row.id;
    },
    //条数变化
    handleSizeChange_registCount(val) {
      this.add_pageIndex = 1
      this.add_pageSize = val;
      this.add_selectList();
    },
    //页码变化
    handleCurrentChange_registCount(val) {
      this.add_pageIndex = val;
      this.add_selectList();
    },
    //检查账号关闭
    closeDialog() {
      this.tableData_registCoun_disabled = false;
      this.add_getData.serviceName=""
      this.add_getData.userEnvironment=""
      this.add_getData.serviceStatus=""
      this.selectList();
      this.toggleSelection_clear();
    },
    //=====================================
    //重置
    Reset() {
      this.add_pageIndex = 1
      this.$refs["add_getData"].resetFields();
      this.add_selectList();
    },
    //查询----------新增
    search() {
      this.add_pageIndex = 1
      this.add_selectList();
    },
    //新增
    addData() {
      this.dialogTableVisible = true;
      this.add_selectList();
    },
    //获取新增列表
    add_selectList() {
      try {
        const params = {
          serviceName: this.add_getData.serviceName, // 服务名称
          pageIndex: this.add_pageIndex, // 当前页  【必填】
          pageSize: this.add_pageSize, // 每页数量  【必填】
          userEnvironment: this.add_getData.userEnvironment, // 使用环境
          relateId: this.IDlist.id, // 账号  【必填】
          serviceStatus: this.add_getData.serviceStatus // 服务状态  0 下架 1上架
        };
        this.loading = true 
        // console.log(params, '参数')
        add_list(params).then(res => {
          const data = res.data;
          // console.log("新增获取到的列表", data);
          if (data.status === 1000) {
            this.loading = false
            this.total_registCount = data.result.realTotal;
            this.add_total = data.result.total;
            this.add_tableData = data.result.records;
            this.add_tableData.forEach(item => {
              if (item.status == 0) {
                item.status_name = "已下架";
              } else if (item.status == 1) {
                item.status_name = "已上架";
              }
            });
            //全部选中状态下
            this.$nextTick(() => {
              if (this.change_All) {
                this.add_tableData.forEach(row => {
                  this.$refs.multipleTable.toggleRowSelection(row, true);
                });
                this.$nextTick(() => {
                  for (let i = 0; i < this.add_tableData.length; i++) {
                    for (let j = 0; j < this.multipleSelection_no.length; j++) {
                      if (
                        this.add_tableData[i].id ===
                        this.multipleSelection_no[j].id
                      ) {
                        this.$refs.multipleTable.toggleRowSelection(
                          this.add_tableData[i],
                          false
                        );
                      }
                    }
                  }
                });
              }
            });
          } else{
            this.$message.error(data.msg)
          }
        });
      } catch (err) {
        this.loading = false
        console.log(err);
      }
    },
    //===========
    //获取列表
    selectList() {
      try {
        const params = {
          relateId: this.IDlist.id, // 账号  【必填】
          pageIndex: this.pageIndex, // 当前页  【必填】
          pageSize: this.pageSize, // 每页数量  【必填】
          dataSortStr: this.orderConfig, // 数据排序
          advancedSearch: this.hignSearchRes // 高级检索
        };
        this.tableLoading = true  
        // debugger
        list(params).then(res => {
           this.tableLoading = false 
          const data = res.data;
          console.log("个人-------", data);
          if (data.status === 1000) {
            this.total = data.result.total;
            this.tableData = data.result.records;
            this.tableData.forEach(item => {
              if (item.status == 0) {
                item.status_name = "已下架";
                item.color = "red";
              } else if (item.status == 1) {
                item.status_name = "已上架";
                item.color = "green";
              }
            });
          } else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
        });
      } catch (err) {
        this.tableLoading = false
        console.log(err);
      }
    },
    //条数变化
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);】
      this.pageIndex = 1
      this.pageSize = val;
      this.selectList();
    },
    //页码变化
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pageIndex = val;
      this.selectList();
    },
    //-----------------------------------------------------------------------
    // 上移
    // moveUp(index, row) {
    //   const Vm = this;
    //   console.log("上移", index, row);
    //   if (index > 0) {
    //     Vm.originData = JSON.parse(JSON.stringify(Vm.tableData));
    //     let upDate = Vm.tableData[index - 1];
    //     Vm.tableData.splice(index - 1, 1);
    //     Vm.tableData.splice(index, 0, upDate);
    //   } else {
    //     Vm.$message.warning("已经是第一条，不可上移");
    //   }
    // },
    // moveDown(index, row) {
    //   const Vm = this;
    //   console.log("下移", index, row);
    //   if (index + 1 === Vm.tableData.length) {
    //     Vm.$message.warning("已经是最后一条，不可下移");
    //   } else {
    //     // console.log(index);
    //     Vm.originData = JSON.parse(JSON.stringify(Vm.tableData));
    //     let downDate = Vm.tableData[index + 1];
    //     Vm.tableData.splice(index + 1, 1);
    //     Vm.tableData.splice(index, 0, downDate);
    //   }
    // },
    // 行拖拽
    initSortabel() {
      const el = document.querySelector(".fields-table .el-table__body tbody");
      const Vm = this;
      console.log("el", el);
      Vm.sortable = new Sortable(el, {
        animation: 300,
        onEnd(evt) {
          // 拖拽结束发生该事件
          Vm.tableData.splice(
            evt.newIndex,
            0,
            Vm.tableData.splice(evt.oldIndex, 1)[0]
          );
          const newArray = Vm.tableData.slice(0);
          Vm.tableData = [];
          Vm.$nextTick(() => {
            Vm.tableData = newArray;
          });
        }
      });
    },
    //确定撤回
    withdrawFN_FN() {
      const row = this.danceRow;
      try {
        // console.log(this.$store.state);
        const params = {
          messageIds: row.messageId, //消息id 多个 ,隔开
          account: this.$store.state.user.userInfo.account, //当前登录用户id this.$store.state.user.tenantId
          tenantId: this.$store.state.user.tenantId
        };
        revocation(params).then(res => {
          const data = res.data;
          if (data.status === 1000) {
            console.log("成功");
            this.selectList();
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          } else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
      this.noticeModal_dance = false;
    },
    //撤回
    withdrawFN(row) {
      this.noticeModal_dance = true;
      this.danceRow = row;
      // console.log(this.$store.state)
      // this.$confirm("确定撤回?", "确认操作", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // })
      //   .then(() => {
      //     try {
      //       console.log(this.$store.state);
      //       const params = {
      //         messageIds: row.messageId, //消息id 多个 ,隔开
      //         account: this.$store.state.user.userInfo.account, //当前登录用户id this.$store.state.user.tenantId
      //         tenantId: this.$store.state.user.tenantId
      //       };
      //       revocation(params).then(res => {
      //         const data = res.data;
      //         if (data.status === 1000) {
      //           console.log("成功");
      //           this.selectList();
      //           this.$message({
      //             type: "success",
      //             message: "操作成功!"
      //           });
      //         } else {
      //           this.$message({
      //             type: "error",
      //             message: data.msg
      //           });
      //         }
      //       });
      //     } catch (err) {
      //       console.log(err);
      //     }
      //   })
      //   .catch(() => {
      //     // this.$message({
      //     //   type: "info",
      //     //   message: "已取消操作"
      //     // });
      //   });
    },
    //确定撤回
    withdrawFNArr_FN() {
      try {
        const params = {
          messageIds: this.messageIdsArr, //消息id 多个 ,隔开
          account: this.$store.state.user.userInfo.account, //当前登录用户id this.$store.state.user.tenantId
          tenantId: this.$store.state.user.tenantId
        };
        revocation(params).then(res => {
          const data = res.data;
          if (data.status === 1000) {
            this.selectList();
            this.$refs.multipleTable.clearSelection();
            console.log("成功");
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          } else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
      this.noticeModal_duoce = false;
    },
    //多选撤回
    withdrawFNArr() {
      if (this.messageIdsArr == "") {
        this.$message.warning("请选择数据");
        return;
      }
      this.noticeModal_duoce = true;
      // this.$confirm("确定撤回?", "确认操作", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // })
      //   .then(() => {
      //     try {
      //       const params = {
      //         messageIds: this.messageIdsArr, //消息id 多个 ,隔开
      //         account: this.$store.state.user.userInfo.account, //当前登录用户id this.$store.state.user.tenantId
      //         tenantId: this.$store.state.user.tenantId
      //       };
      //       revocation(params).then(res => {
      //         const data = res.data;
      //         if (data.status === 1000) {
      //           this.selectList();
      //           this.$refs.multipleTable.clearSelection();
      //           console.log("成功");
      //           this.$message({
      //             type: "success",
      //             message: "操作成功!"
      //           });
      //         } else {
      //           this.$message({
      //             type: "error",
      //             message: data.msg
      //           });
      //         }
      //       });
      //     } catch (err) {
      //       console.log(err);
      //     }
      //   })
      //   .catch(() => {
      //     // this.$message({
      //     //   type: "info",
      //     //   message: "已取消操作"
      //     // });
      //   });
    },
    //重置
    resetForm() {
      this.$refs.multipleTable.clearSelection();
      this.valuedata = "";
      this.formInline = {
        mpId: this.ID.userId, //公众号的IM账号
        title: "", //标题 模糊查询，
        content: "", //内容 模糊查询，
        sendUserName: "", //发送人 模糊查询，
        willSchedule: "-1", //是否定时 0是  1不是，默认为-1
        equirment: "-1", //平台 0所有  1android 2IOS，默认为-1
        startTime: "", //发布时间段的开始时间 毫秒级
        endTime: "", //发布时间段的结束时间  毫秒级
        pageIndex: 1, //页码
        pageSize: 40 //每页行数
      };
      this.selectList();
    },
    //查询
    searchFN() {
      this.formInline.title = this.formInline.title.trim();
      this.formInline.content = this.formInline.content.trim();
      this.$refs.multipleTable.clearSelection();
      if (this.valuedata) {
        let date_1 = new Date(this.valuedata[0]);
        let time_1 = date_1.getTime();
        this.formInline.startTime = time_1;
        let date_2 = new Date(this.valuedata[1]);
        let time_2 = date_2.getTime();
        this.formInline.endTime = time_2;
      } else {
        this.formInline.startTime = "";
        this.formInline.endTime = "";
      }

      this.selectList();
    },

    //撤回记录
    WithdrawalOfRecords() {
      this.$emit("ToWithdrawalOfRecords", this.ID);
    },
    //返回
    goBack() {
      this.$emit("backHome");
    },
    //获取label
    getLabel(val) {
      this.formInline.SSxiaoquID = val;
      console.log("这是SSxiaoquID", this.formInline.SSxiaoquID);
    },

    //获取发布人列表
    selectFBR() {
      try {
        const params = this.ID.userId;
        sendUserList(params).then(res => {
          const data = res.data;
          if (data.status === 1000) {
            console.log("发布人", data);
            this.selectFBRdata = data.result;
          } else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //查询详情
    details(row) {
      this.$emit("ToDetailsPage", { row: row, Back: this.Back, ID: this.ID });
    },

    //页面变化时
    pageChanageSelect() {
      console.log("切换", this.checkClassList);
    },

    getSessonValue(name) {
      return getStore({
        name: name,
        type: "session"
      });
    }
  }
};
</script>

<style lang="scss">
.third {
  .PersonalPresetService {
    .old-table {
      .el-table__body-wrapper {
        height: calc(100vh - 180px) !important;
      }
    }
  }
}
.my-table-geadd{
  .el-table__body-wrapper{
    height: 295px !important;
  }
}
.el-date-editor .el-range-separator {
  padding: 0 !important;
  width: 15% !important;
}
</style>
